"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const link_1 = __importDefault(require("next/link"));
const Link = ({ href, children, ariaDisabled, rel, locale, title, className, onClick = undefined }) => {
    return ((0, jsx_runtime_1.jsx)(link_1.default, Object.assign({ href: href, passHref: true }, locale && { locale }, onClick && { onClick }, { children: (0, jsx_runtime_1.jsx)("a", Object.assign({}, rel && { rel }, ariaDisabled && { 'aria-disabled': ariaDisabled }, title && { title }, className && { className }, { children: children })) })));
};
exports.Link = Link;
